<template>
  <div class="ControlSystem">
    <div class="page_img">
      <img src="@/assets/img/control_system.jpg" alt="">
    </div>
    <div class="page_content content flex_row">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="font_shadow page_summary">校医联盟近视防控系统</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/control_main.png" alt="">
      <div class="main_explain control_explain">落实视力健康管理各项措施的关键，建立早期预防观念。辅助学校进行学生健康因素状况评估考核以及群体近视预防健康干预</div>
    </div>
    <div class="system">
      <div class="sys_back"><img src="@/assets/img/control_back.png" alt=""></div>
      <div class="sys_main">
        <img src="@/assets/img/control_main1.png" alt="">
      </div>
    </div>

    <div class="page_system flex_column screen">
      <div class="sys_title flex_column screen_title">
        <div class="screen_summary">智慧视典眼健康筛查系统</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="screen_content flex_column">
        <div class="screen_item" v-for="item in list">
          <span></span>
          {{ item }}
        </div>
      </div>
    </div>

    <div class="device">
      <div class="device_main flex_row">
        <div class="device_item1 flex_row">
          <img src="@/assets/img/control_device1.png" alt="">
          <img src="@/assets/img/control_device2.png" alt="">
        </div>
        <div class="device_item">
        </div>
        <div class="device_item">
        </div>
      </div>
      <div class="device_main flex_row">
        <div class="device_item1 flex_row">
          <img src="@/assets/img/control_device4.png" alt="">
          <img src="@/assets/img/control_device3.png" alt="">
        </div>
        <div class="device_item">
          <img src="@/assets/img/control_device5.png" alt="">
        </div>
        <div class="device_item">
          <img src="@/assets/img/control_device6.png" alt="">
        </div>
      </div>
    </div>

    <div class="control flex_row">
      <div class="control_shell flex_row" v-for="item in iconList">
        <div class="control_item flex_row" >
          <div class="icon_left">
            <img :src="item.src" alt="">
          </div>
          <div class="icon_right flex_column">
            <div class="icon_top">{{item.title}}</div>
            <div class="icon_info">{{item.info}}</div>
          </div>
        </div>
      </div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'ControlSystem',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
      list: [],
      iconList: []
    }
  },
  created() {
    let list = ['专为中国儿童青少年近视防控设计，可对接国家指定数据库、Epidata数据库，并支持导入“全国学生常见病和健康影响因素监测信息','符合《儿童青少年近视普查工作流程专家共识（2019）》','符合《儿童青少年近视普查信息化管理专家共识（2019）》','符合《2019年全国学生常见病和健康影响因素监测及干预工作手册》、2020年《中小学生屈光不正筛查规范》','集眼科基础疾病参数筛查、数据监测、预警随访、眼健康管理为一体'];
    let iconList = [
      {
        src: 'https://ow.visumall.com/public/img/control_icon1.png',
        title: '智能筛查终端',
        info: '(用于校园无人值守普查）',
      },
      {
        src: 'https://ow.visumall.com/public/img/control_icon2.png',
        title: '儿童青少年视力监测平台',
        info: '（用于数据监测）',
      },
      {
        src: 'https://ow.visumall.com/public/img/control_icon3.png',
        title: '眼健康平台',
        info: '（用于报告查询）',
      },
    ]
    this.list =  list;
    this.iconList = iconList;
  },
}
</script>

<style scoped lang="scss">
.ControlSystem {
  .content {
    margin: 0.4rem 0 1.5rem;
  }
  .main {
    width: 100%;
    margin-bottom: 0.7rem;
    img {
      width: 50%;
    }
    .control_explain {
      text-align: left;
      margin-top: 0.5rem;
      font-weight: 500;
      width: 65%;
      padding: 0.25rem 0.45rem;
      font-size: 0.19rem;
    }
  }
  .system {
    margin-bottom: 1rem;
    .sys_back {
      opacity: 0.15;
      position: relative;
      width: 100%;
      z-index: -1;
      img {
        position: absolute;
        width: 100%;
        left: 50%;
        transform: translate(-50%,-5%);
        z-index: -1;
      }
    }
    .sys_main {
      img {
        width: 55%;
      }
    }
  }
  .screen {
    margin-top: 1.3rem;
    margin-bottom: 1.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .screen_title {
      margin-bottom: 0.5rem;
      .screen_summary {
        font-size: 0.3rem;
        font-weight: bold;
        text-align: center;
      }
      //.line_circle {
      //  width: 80%;
      //  margin-top: 0.25rem;
      //  display: flex;
      //  flex-direction: column;
      //  position: relative;
      //  .line {
      //    height: 0.01rem;
      //    background: #D7D7D7;
      //  }
      //  .circle {
      //    position: absolute;
      //    left: 50%;
      //    top: 0;
      //    transform: translate(-50%, -50%);
      //    width: 0.14rem;
      //    height: 0.14rem;
      //    border: 0.01rem solid #D7D7D7;
      //    background: #fff;
      //    border-radius: 50%;
      //  }
      //}
    }
    .screen_content {
      .screen_item {
        position: relative;
        margin-top: 0.11rem;
        padding-left: 0.3rem;
        span {
          left: 0;
          top: 0;
          transform: translate(100%,50%);
          position: absolute;
          width: 0.11rem;
          height: 0.11rem;
          background: #7ECEF4;
          border-radius: 50%;
        }
        width: 100%;
        text-align: left;
        font-size: 0.20rem;
      }
    }
  }
  .device {
    .device_top {
      justify-content: flex-start;
    }
    .device_top, .device_main{
      display: flex;
      .device_item {
        width: 30%;
        img {
          width: 100%;
        }
      }
      .device_item1 {
        width: 30%;
        img {
          flex: 1;
          width: 50%;
        }
      }
      .device_item2 {
        margin-left: 1rem;
      }
    }

  }
  .control {
    margin: 0.6rem 0 0.8rem;
    //justify-content: space-around;
    .control_shell {
      width: 30%;
      .control_item {
        width: 60%;
        //margin: 0 0.37rem;
        background: #5575FF;
        display: flex;
        padding: 0.35rem 0.19rem;
        .icon_left {
          margin-right: 0.15rem;
          img {
            width: 0.64rem;
            height: 0.64rem;
          }
        }
        .icon_right {
          //margin-left: 0.15rem;
          //justify-content: space-around;
          .icon_top {
            font-size: 0.18rem;
            font-weight: 800;
            color: #FEFEFE;
          }
          .icon_info {
            margin-top: 0.17rem;
            font-size: 0.15rem;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
</style>
